import { useRef } from "react";

type LockerverseResourceIdentity = {
  apiBaseUrl: string | undefined;
  communitySlug: string;
  mediaBaseUrl?: string | undefined;
  environment: string | undefined;
  slug: string;
  previewItemSlug?: string | undefined;
};

function hasSameIdentity(
  initial: LockerverseResourceIdentity,
  current: LockerverseResourceIdentity
) {
  return (
    initial.apiBaseUrl === current.apiBaseUrl &&
    initial.communitySlug === current.communitySlug &&
    initial.mediaBaseUrl === current.mediaBaseUrl &&
    initial.environment === current.environment &&
    initial.slug === current.slug &&
    initial.previewItemSlug === current.previewItemSlug
  );
}

export function useImmutableResourceIdentity(
  resource:
    | "payment widget"
    | "signup"
    | "auctions"
    | "auction"
    | "public events",
  identity: LockerverseResourceIdentity
) {
  const initial = useRef(identity);
  if (!hasSameIdentity(initial.current, identity)) {
    throw new TypeError(
      `Lockerverse ${resource} identity cannot change after initialization. Remount with a new React key.`
    );
  }
}
